import React from "react";
import { Locale, Translations } from "@gf-easy-8/grmnext-foundation";
import { Labels } from "./TranslationProvider/translations";
import Listeners from "../listener/Listeners";
import { PermissionProvider } from "./PermissionProvider";
import { StatusBarProvider } from "./StatusBarProvider";
import { SnackBarProvider } from "./SnackBarProvider";

export const RootProvider = ({
  children,
}: JSX.ElementChildrenAttribute): JSX.Element => {
  return (
    <PermissionProvider>
      <StatusBarProvider>
        <Translations labels={Labels}>
          <SnackBarProvider>
            <Listeners />
            <Locale>{children}</Locale>
          </SnackBarProvider>
        </Translations>
      </StatusBarProvider>
    </PermissionProvider>
  );
};
